import React from 'react';
import InfiniteCanvas from './components/canvas/InfiniteCanvas';
import { PosterProvider } from './context/PosterContext';
import { useWebSocket } from './hooks';
import './App.css';

function App() {
  const { socket } = useWebSocket();

  return (
    <PosterProvider socket={socket}>
      <InfiniteCanvas />
    </PosterProvider>
  );
}

export default App;
